"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMessageStreamRequest = exports.UpdateMessageStreamRequest = exports.UnsubscribeHandlingTypes = void 0;
var UnsubscribeHandlingTypes;
(function (UnsubscribeHandlingTypes) {
    UnsubscribeHandlingTypes["None"] = "None";
    UnsubscribeHandlingTypes["Postmark"] = "Postmark";
    UnsubscribeHandlingTypes["Custom"] = "Custom";
})(UnsubscribeHandlingTypes = exports.UnsubscribeHandlingTypes || (exports.UnsubscribeHandlingTypes = {}));
var UpdateMessageStreamRequest = /** @class */ (function () {
    function UpdateMessageStreamRequest(name, description, subscriptionManagementConfiguration) {
        this.Name = name;
        this.Description = description;
        this.SubscriptionManagementConfiguration = subscriptionManagementConfiguration;
    }
    return UpdateMessageStreamRequest;
}());
exports.UpdateMessageStreamRequest = UpdateMessageStreamRequest;
var CreateMessageStreamRequest = /** @class */ (function () {
    function CreateMessageStreamRequest(id, name, messageStreamType, description, subscriptionManagementConfiguration) {
        this.Name = name;
        this.Description = description;
        this.ID = id;
        this.MessageStreamType = messageStreamType;
        this.SubscriptionManagementConfiguration = subscriptionManagementConfiguration;
    }
    return CreateMessageStreamRequest;
}());
exports.CreateMessageStreamRequest = CreateMessageStreamRequest;
//# sourceMappingURL=MessageStream.js.map